// 一级导航的曝光
function pcNavFirstDataLayerExposure(pageName) {
    // 用 Set 记录已曝光的一级导航
    const exposedNavItems = new Set();

    // 创建 IntersectionObserver 实例
    const pcNavObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            console.log('是否曝光',entry,entry.isIntersecting);
            if (entry.isIntersecting) {
                console.log('进入导航曝光:', entry.target);

                // 遍历所有导航项
                let items = [];
                $('.Header__MainNav .HorizontalList .first_nav').each(function(index) {
                    const navText = $(this).find('a.Heading.u-h6').contents()
                        .filter(function() { return this.nodeType === Node.TEXT_NODE; })
                        .text().trim();

                    const navHref = $(this).find('> a').attr('href');

                    // 如果该导航已曝光过，则跳过
                    if (exposedNavItems.has(navHref)) {
                        console.log(`❌ 已曝光，跳过: ${navText}`);
                        return;
                    }

                    // 记录曝光
                    exposedNavItems.add(navHref);

                    console.log(`✅ 触发曝光: ${navText}`);
                    items.push({
                        item_name: `stair-${navText}`,
                        item_id: 'menu_stair',
                        promotion_id: 'menu_stair',
                        promotion_name: `stair-${navText}`,
                        creative_name: navHref,
                        creative_slot: index,
                    });
                });

                if (items.length > 0) {
                    // 推送数据到 dataLayer
                    dataLayer.push({
                        event: "dle_view_promotion",
                        dlv_ec: `${pageName}`,
                        dlv_ea: 'navBar',
                        dlv_el: 'menu_stair',
                        ecommerce: { items }
                    });
                    console.log('曝光所有内容',items);
                }

                // **不取消整个观察器，而是逐个移除已曝光的项**
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.8 }); // 只有完全进入视口时才触发

    // 选择并观察导航元素
    const navElement = document.querySelector('.Header__MainNav');
    if (navElement) {
        pcNavObserver.observe(navElement);
    }
}
// 一级导航的点击
function pcNavFirstDataLayerClick(pageName) {
    console.log('导航');
    // 如果已经触发过曝光事件，就不再触发
    // 绑定点击事件监听器
    $('.Header__MainNav .HorizontalList .first_nav').on('click', function(event) {
        console.log('点击一级',$(event.target));
        if ($(event.target).closest('.third_menu').length > 0) {
            return; // 如果点击的是三级导航，就不继续执行一级逻辑
        }
        var index = $(this).index(); // 获取当前点击项的索引
        console.log('点击nav，索引为:', index);
        // 如果已经触发过曝光事件，直接返回
        if (!$(this).data('exposed')) {
            // 获取当前点击的 li 内容或数据
            var itemName = $(this).find('a.Heading.u-h6').contents()
            .filter(function() { return this.nodeType === Node.TEXT_NODE; })
            .text().trim(); // 获取点击的项的名称
            var itemId = 'menu_stair';      // 获取 item ID
            var promotionId = 'menu_stair';
            var promotionName = $(this).find('a.Heading.u-h6').contents()
            .filter(function() { return this.nodeType === Node.TEXT_NODE; })
            .text().trim();
            var creative_name = $(this).find('a').attr('href');
            var creative_slot = index;
            console.log('点击一级导航一次',index,itemName,promotionName);
            // 推送到 dataLayer 作为曝光事件
            dataLayer.push({ ecommerce: null });  // 清空之前的数据
            dataLayer.push({
                event: "dle_select_promotion",
                dlv_ec: `${pageName}`,
                dlv_ea: 'navBar',
                dlv_el: 'menu_stair',
                ecommerce: {
                    items: [
                        {
                            item_name: `stair-${itemName}`,
                            item_id: itemId,
                            promotion_id: promotionId,
                            promotion_name: `stair-${itemName}`,
                            creative_name: creative_name,
                            creative_slot: creative_slot,
                        }
                    ]
                }
            });
            $(this).data('exposed', true); // 标记已曝光
        }
    });
}
// 二级导航的点击
function pcNavSecondDataLayerClick(itemList,index) {
    console.log('二级导航显示',itemList);
    if (!itemList.data('exposed')) {
        var firstNavName = itemList.closest(".HorizontalList__Item.first_nav").find('a.Heading.u-h6').contents()
        .filter(function() { return this.nodeType === Node.TEXT_NODE; })
        .text().trim();
        if(itemList.hasClass('two_MegaMenu__Inner_pic_first')){
            console.log('点击的是大图');
            var secondNavName = 'banner';
            var secondNavHref = itemList.find('> a').attr("href");
        }else{
            console.log('点击的是其他');
            var secondNavName = itemList.find('> a').find("p").text().trim();
            var secondNavHref = itemList.find('> a').attr("href");
        }

        var secondNavIndex = index;
        // 推送到 dataLayer 作为曝光事件
        dataLayer.push({ ecommerce: null });  // 清空之前的数据
        dataLayer.push({
            event: "dle_select_promotion",
            dlv_ec: `${pageName}`,
            dlv_ea: 'navBar',
            dlv_el: 'menu_secondary',
            ecommerce: {
                items: [{
                    item_name: `secondary-${firstNavName}::${secondNavName}`,
                    item_id: "menu_secondary",
                    promotion_id: "menu_secondary",
                    promotion_name: `secondary-${firstNavName}::${secondNavName}`,
                    creative_name: secondNavHref,
                    creative_slot: secondNavIndex, // 记录当前项的位置
                }]
            }
        });
        itemList.data('exposed', true);// 标记已曝光
    }
   
}
function pcNavSecondDataLayerClickOne(itemList,index){

    if (!itemList.data('exposed')) {
        var firstNavName = itemList.closest(".HorizontalList__Item.first_nav").find('a.Heading.u-h6').contents()
        .filter(function() { return this.nodeType === Node.TEXT_NODE; })
        .text().trim();
        if(itemList.parent().hasClass('two_MegaMenu__Inner_pic_first')){
            var secondNavName = 'banner';
            console.log('点击的是大图',itemList,secondNavName);
        }else{
            var secondNavName = itemList.text().trim();
        }
    
        var secondNavHref = itemList.attr("href");
        var secondNavIndex = index;
        // 推送到 dataLayer 作为曝光事件
        dataLayer.push({ ecommerce: null });  // 清空之前的数据
        dataLayer.push({
            event: "dle_select_promotion",
            dlv_ec: `${pageName}`,
            dlv_ea: 'navBar',
            dlv_el: 'menu_secondary',
            ecommerce: {
                items: [{
                    item_name: `secondary-${firstNavName}::${secondNavName}`,
                    item_id: "menu_secondary",
                    promotion_id: "menu_secondary",
                    promotion_name: `secondary-${firstNavName}::${secondNavName}`,
                    creative_name: secondNavHref,
                    creative_slot: secondNavIndex, // 记录当前项的位置
                }]
            }
        });
        itemList.data('exposed', true);// 标记已曝光
    }
}
// 三级导航的点击
function pcNavThirdDataLayerClick(itemList,index) {
    console.log('进入三级导航点击事件');
    if (!itemList.data('exposed')) {
        var firstNavName = itemList.closest(".HorizontalList__Item.first_nav").find('a.Heading.u-h6').contents()
        .filter(function() { return this.nodeType === Node.TEXT_NODE; })
        .text().trim();
        console.log('三级分类名称',itemList.closest(".have_third_secondMenu").find('> a').find("p").text().trim());
        var secondNavName = itemList.closest(".have_third_secondMenu").find('> a').find("p").text().trim();
        var thirdNavName = itemList.find('a').find("p").text().trim();
        var thirdNavHref = itemList.find('a').attr("href");
        var thirdNavIndex = index;
        // 推送到 dataLayer 作为曝光事件
        dataLayer.push({ ecommerce: null });  // 清空之前的数据
        dataLayer.push({
            event: "dle_select_promotion",
            dlv_ec: `${pageName}`,
            dlv_ea: 'navBar',
            dlv_el: 'menu_third',
            ecommerce: {
                items: [{
                    item_name: `third-${firstNavName}::${secondNavName}::${thirdNavName}`,
                    item_id: "menu_third",
                    promotion_id: "menu_third",
                    promotion_name: `third-${firstNavName}::${secondNavName}::${thirdNavName}`,
                    creative_name: thirdNavHref,
                    creative_slot: thirdNavIndex, // 记录当前项的位置
                }]
            }
        });
        itemList.data('exposed', true);// 标记已曝光
    }

}
// 二级导航的曝光
// 存储已曝光的二级导航，避免重复曝光
const exposedSecondaryNav = new Set();
const exposedSetThirdNav = new Set(); // 避免重复曝光
// 创建 IntersectionObserver 监听二级导航曝光
const pcNavSecondObserver = new IntersectionObserver((entries) => {
    let newExposedItems = [];
    let thirdNewExposedItems = [];
    entries.forEach(entry => {
        console.log('二级导航遍历');
        if (entry.isIntersecting) {
            const subMenu = $(entry.target);
            const parentNav = subMenu.closest(".HorizontalList__Item.first_nav").find("> a"); // 找到对应的一级导航
            const href = parentNav.attr("href");
            const itemName = parentNav.contents().filter(function() {
                return this.nodeType === Node.TEXT_NODE; // 只获取一级导航的文本
            }).text().trim();
            console.log('二级导航对应内容',subMenu,href,itemName);
            if(subMenu.find('.third_menu').length>0){
                console.log('包含3级导航的内容',subMenu);
                subMenu.find(".two_MegaMenu__Inner_pic_first a").each(function (secondIndex) {
                    console.log('二级左侧内容',$(this).attr("href"));
                    let secondHref = $(this).attr("href"); // 二级导航链接
                    let secondName = "";
                    if($(this).parent().hasClass('two_MegaMenu__Inner_pic_first')){
                        secondName = 'banner'; // 二级导航文本
                    }else{
                        secondName = $(this).find(".erji_title_pic").text().trim(); // 二级导航文本
                    }
                    if (secondHref && !exposedSecondaryNav.has(secondHref)) {
                        exposedSecondaryNav.add(secondHref); // 记录二级导航曝光
                        let item = {
                            item_name: `secondary-${itemName}::${secondName}`,
                            item_id: "menu_secondary",
                            promotion_id: "menu_secondary",
                            promotion_name: `secondary-${itemName}::${secondName}`,
                            creative_name: secondHref,
                            creative_slot: secondIndex, // 记录当前项的位置
                            menuType: "menu_secondary"
                        };
                        newExposedItems.push(item);
                        console.log('二级左侧曝光',item);
                        
                    }
                })
                const firstLevelLinks = subMenu.closest(".HorizontalList__Item.first_nav").find('.secondNavLinklist .two_Linklist_right').find('> li');
                console.log('二级内容',subMenu.closest(".HorizontalList__Item.first_nav").find('.secondNavLinklist .two_Linklist_right').find('> li'));
                firstLevelLinks.each(function (secondIndex) {
                    console.log('二级内容02',$(this),$(this).find('> a').attr("href"));
                    let secondHref = $(this).find('> a').attr("href"); // 二级导航链接
                    let secondName = "";
                    // if($(this).parent().hasClass('two_MegaMenu__Inner_pic_first')){
                    //     secondName = 'banner'; // 二级导航文本
                    // }else{
                        secondName = $(this).find('> a').find("p").text().trim(); // 二级导航文本
                    // }
                    if (secondHref && !exposedSecondaryNav.has(secondHref)) {
                        exposedSecondaryNav.add(secondHref); // 记录二级导航曝光
                        let item = {
                            item_name: `secondary-${itemName}::${secondName}`,
                            item_id: "menu_secondary",
                            promotion_id: "menu_secondary",
                            promotion_name: `secondary-${itemName}::${secondName}`,
                            creative_name: secondHref,
                            creative_slot: secondIndex, // 记录当前项的位置
                            menuType: "menu_secondary"
                        };
                        newExposedItems.push(item);
                        console.log('二级右侧曝光',item);
                       
                        
                    }
                })
                 // 三级导航
                 var thirdLevelLinks = firstLevelLinks.find('.third_menu .Linklist__Item');
                 console.log('三级内容',thirdLevelLinks,thirdLevelLinks.length);
                 thirdLevelLinks.each(function (thirdIndex) {
                    console.log('三级内容02',$(this).closest(".have_third_secondMenu").find('> a').find("p").text().trim(),$(this).find('> a').attr("href"));
                    var secondNavName = $(this).closest(".have_third_secondMenu").find('> a').find("p").text().trim();
                    let thirdHref = $(this).find('> a').attr("href"); // 三级导航链接
                    let thirdName = $(this).find('> a').find("p").text().trim(); // 三级导航文本
                    if (thirdHref && !exposedSetThirdNav.has(thirdHref)) {
                        exposedSetThirdNav.add(thirdHref); // 记录三级导航曝光
                        let item = {
                            item_name: `third-${itemName}::${secondNavName}::${thirdName}`,
                            item_id: "menu_third",
                            promotion_id: "menu_third",
                            promotion_name: `third-${itemName}::${secondNavName}::${thirdName}`,
                            creative_name: thirdHref,
                            creative_slot: thirdIndex, // 记录当前项的位置
                            menuType: "menu_third"
                        };
                        thirdNewExposedItems.push(item);
                        console.log('三级右侧曝光',item);
                       
                        
                    }
                 })
            }else{
                subMenu.find(".Linklist a").each(function (secondIndex) {
                    console.log('二级内容',$(this).attr("href"));
                    let secondHref = $(this).attr("href"); // 二级导航链接
                    let secondName = "";
                    if($(this).parent().hasClass('two_MegaMenu__Inner_pic_first')){
                        secondName = 'banner'; // 二级导航文本
                    }else{
                        secondName = $(this).find(".erji_title_pic").text().trim(); // 二级导航文本
                    }
                    if (secondHref && !exposedSecondaryNav.has(secondHref)) {
                        exposedSecondaryNav.add(secondHref); // 记录二级导航曝光
                        let item = {
                            item_name: `secondary-${itemName}::${secondName}`,
                            item_id: "menu_secondary",
                            promotion_id: "menu_secondary",
                            promotion_name: `secondary-${itemName}::${secondName}`,
                            creative_name: secondHref,
                            creative_slot: secondIndex, // 记录当前项的位置
                            menuType: "menu_secondary"
                        };
                        newExposedItems.push(item);
                        console.log('二级曝光',item);
                        
                    }
                })
            }
  
                console.log('所有的二级曝光',newExposedItems);
                console.log('所有的三级曝光',thirdNewExposedItems);
            pcNavSecondObserver.unobserve(entry.target); // 停止观察已曝光的导航
        }
    });

    if (newExposedItems.length > 0) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "dle_view_promotion",
            dlv_ec: `${pageName}`,
            dlv_ea: "navBar",
            dlv_el: "menu_secondary",
            ecommerce: {
                items: newExposedItems
            }
        });
        console.log("二级导航曝光内容：", newExposedItems);
    }
    if (thirdNewExposedItems.length > 0) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "dle_view_promotion",
            dlv_ec: `${pageName}`,
            dlv_ea: "navBar",
            dlv_el: "menu_third",
            ecommerce: {
                items: thirdNewExposedItems
            }
        });
        console.log("三级导航曝光内容：", newExposedItems);
    }
}, { threshold: 0.1 });


var pageName = 'HomePage';
$(function(){
    console.log('header是否引入');
    if (jQuery('body').hasClass('template-index')) {
        pageName = 'HomePage'
    } else if (jQuery('body').hasClass('template-search')) {
        pageName = 'search'
    } else if (jQuery('PageOverlay').hasClass('is-visible')) {
        pageName =  'search'
    } else if (jQuery('body').hasClass('template-collection')) {
        pageName =  'productList'
    } else if (jQuery('body').hasClass('template-product')) {
        pageName =  'productDetail'
    } else if (jQuery('body').hasClass('template-cart')) {
        pageName =  'cartCheckout'
    } else if (jQuery('body').hasClass('template-customers/register')) {
        pageName =  'Signup/Login'
    } else if (jQuery('body').hasClass('template-customers/login')) {
        pageName =  'Signup/Login'
    } else if (jQuery('body').hasClass('template-account')) {
        pageName =  'My Account'
    } else {
        pageName =  'otherPage'
    }

    // 一级导航的曝光
    pcNavFirstDataLayerExposure(pageName);
    // 一级导航的点击
    pcNavFirstDataLayerClick(pageName);

    // 监听一级导航的移入事件，添加曝光
    $(".Header__MainNav .HorizontalList .first_nav").each(function(){
        $(this).find('> a').on("mouseenter", function () {
            const subMenu = $(this).parent().find(".DropdownMenu"); // 获取对应的二级导航
            if(subMenu.find('.third_menu').length>0){
                subMenu.find(".two_MegaMenu__Inner_pic_first").each(function (){
                    $(this).off('click').on('click', function(event){
                        event.stopPropagation(); // 防止冒泡到上层
                        pcNavSecondDataLayerClick($(this), $(this).index());
                    })
                })
                const firstLevelLinks = subMenu.closest(".HorizontalList__Item.first_nav").find('.secondNavLinklist .two_Linklist_right').find('> li');
                firstLevelLinks.each(function () {
                    $(this).off('click').on('click', function(event){
                        event.stopPropagation(); // 防止冒泡到上层
                        pcNavSecondDataLayerClick($(this), $(this).index()+1);
                    })
                })
                var thirdLevelLinks = firstLevelLinks.find('.third_menu .Linklist__Item');
                
                thirdLevelLinks.each(function () {
                    console.log('三级导航',$(this));
                    $(this).find('a').on('click', function (event) {
                        console.log('点击的是三级导航',$(this));
                      event.stopPropagation(); // 阻止事件冒泡
                      pcNavThirdDataLayerClick($(this).closest('.Linklist__Item'), $(this).closest('.Linklist__Item').index(), event);
                    });
                });
            }else{
                subMenu.find(".Linklist a").each(function (secondIndex) {
                    console.log('点击二级导航',subMenu,$(this));
                    $(this).off('click').on('click', function(event){
                        console.log('点击二级导航进入',$(this));
                        event.stopPropagation(); // 防止冒泡到上层
                        pcNavSecondDataLayerClickOne($(this), $(this).index());
                    })
                })
            }
            
            if (subMenu.length) {
                console.log("一级导航移入，二级三级导航曝光监听开启");
                pcNavSecondObserver.observe(subMenu[0]);
            }
        })
    })
})
